export default function BrandTypesPriority() {
  // An array with brand's types set by priority
  return ['BST2', 'BST1', 'BST3', 'BST4'];
}
